/** Fallback texts for live-editable marketing copy (ContentContext). */
export const DEFAULT_TEXTS = {
  "announcement.text": "Stages et ateliers ouverts",
  "announcement.link": "Nous contacter",
  "welcome.popup.badge": "Bonne rentrée !",
  "welcome.popup.title": "Atelier découverte offert",
  "welcome.popup.subtitle": "Testez DigiRobot sans engagement",
  "home.hero.badge": "Dès 6 ans",
  "home.hero.title": "Robotique, Programmation & IA dès 6 ans",
  "home.hero.subtitle": "Ateliers, stages et formations STEM pour préparer vos enfants au monde de demain.",
  /* Si Mongo a encore « CTA test », clear via admin live-edit OU: npm run seed -- --reset-hero-cta */
  "home.hero.cta": "Réserver un atelier",
  "home.hero.ctaSecondary": "Découvrir DigiRobot",
  "home.stats.1.label": "Élèves formés",
  "home.stats.2.label": "Centres en PACA",
  "home.stats.3.label": "Modules pédagogiques",
  "home.stats.4.label": "Satisfaction parents",
  "home.how.eyebrow": "Simple et efficace",
  "home.how.title": "Comment ça marche ?",
  "home.how.subtitle": "Trois étapes pour apprendre la robotique en s'amusant — montage, code et compréhension.",
  "home.how.1.title": "Construire",
  "home.how.1.text": "Les enfants assemblent et donnent vie à leurs robots.",
  "home.how.2.title": "Coder",
  "home.how.2.text": "Ils apprennent à programmer et à résoudre des défis.",
  "home.how.3.title": "Comprendre",
  "home.how.3.text": "Ils développent leur logique, leur créativité et leur autonomie.",
  "home.section.why.title": "Pourquoi la robotique et la programmation ?",
  "home.why.eyebrow": "Notre approche",
  "home.why.subtitle": "Des programmes STEM structurés qui développent la curiosité, la logique et la confiance en soi — des compétences essentielles pour l'école et les métiers de demain.",
  "home.why.1.title": "S.T.E.M Education",
  "home.why.1.text": "Programmes éducatifs captivants pour les enfants de 6 à 18 ans. La programmation ouvre de nouvelles opportunités et favorise une réflexion innovante.",
  "home.why.2.title": "Pédagogie Adaptée",
  "home.why.2.text": "Plus de 50 modules conçus par des experts. Apprentissage ludique et sécurisé avec progression personnalisée par groupes d'âge.",
  "home.why.3.title": "Opportunités",
  "home.why.3.text": "Développement des compétences STEM à travers des concours et projets. Renforce la confiance et l'esprit critique des enfants.",
  "home.values.1.title": "Ingéniosité",
  "home.values.2.title": "Pensée Critique",
  "home.values.3.title": "Créativité",
  "home.values.4.title": "Culture Digitale",
  "home.ages.eyebrow": "Par tranche d'âge",
  "home.ages.title": "Un parcours adapté à chaque enfant",
  "home.ages.subtitle": "De 6 à 16 ans, nos programmes évoluent avec le niveau — du premier robot au code Python et Arduino.",
  "home.ages.1.level": "Initiation",
  "home.ages.1.title": "6 – 8 ans",
  "home.ages.1.text": "Premiers pas en robotique et programmation visuelle.",
  "home.ages.1.highlight.1": "Construction de robots simples",
  "home.ages.1.highlight.2": "Programmation par blocs",
  "home.ages.1.highlight.3": "Projets créatifs",
  "home.ages.1.cta": "En savoir plus",
  "home.ages.2.level": "Perfectionnement",
  "home.ages.2.title": "9 – 12 ans",
  "home.ages.2.text": "Capteurs, actionneurs et projets plus ambitieux.",
  "home.ages.2.highlight.1": "Scratch avancé",
  "home.ages.2.highlight.2": "Capteurs et moteurs",
  "home.ages.2.highlight.3": "Projets collaboratifs",
  "home.ages.2.cta": "En savoir plus",
  "home.ages.3.level": "Expertise",
  "home.ages.3.title": "13 – 16 ans",
  "home.ages.3.text": "Python, Arduino et robots autonomes.",
  "home.ages.3.highlight.1": "Programmation Python",
  "home.ages.3.highlight.2": "Microcontrôleurs",
  "home.ages.3.highlight.3": "Concours internationaux",
  "home.ages.3.cta": "En savoir plus",
  "home.features.eyebrow": "Nos atouts",
  "home.features.title": "Pourquoi choisir DigiRobot ?",
  "home.features.subtitle": "Des ateliers de robotique pensés pour les enfants, approuvés par les parents et reconnus par nos partenaires éducatifs.",
  "home.features.1.title": "Encadrement certifié",
  "home.features.1.text": "Formateurs passionnés, pédagogie éprouvée et environnement sécurisé pour chaque enfant.",
  "home.features.2.title": "Petits groupes",
  "home.features.2.text": "8 à 10 élèves maximum par session pour un suivi attentif et une vraie progression.",
  "home.features.3.title": "Pédagogie ludique",
  "home.features.3.text": "Makeblock, Artec, Scratch et Arduino — apprendre en construisant des robots concrets.",
  "home.features.4.title": "5 centres sur la Côte d'Azur",
  "home.features.4.text": "Nice, Cannes, Monaco, Pégomas et Cagnes-sur-Mer — proche de chez vous.",
  "home.features.5.title": "Compétences du futur",
  "home.features.5.text": "Logique, créativité et culture digitale — des atouts essentiels pour demain.",
  "home.features.6.title": "Matériel professionnel",
  "home.features.6.text": "Kits robotiques, capteurs et outils de qualité — tout est fourni sur place.",
  "home.workshop.eyebrow": "En atelier",
  "home.workshop.title": "Apprendre en construisant de vrais robots",
  "home.workshop.subtitle": "Chaque séance mêle montage, programmation et créativité — dans nos centres équipés sur la Côte d'Azur.",
  "home.workshop.cta": "Voir nos ateliers",
  "home.section.offers.title": "Nos Offres Principales",
  "home.section.offers.subtitle": "Trois parcours adaptés à chaque rythme — de la découverte aux formations annuelles complètes",
  "home.offers.eyebrow": "Nos formules",
  "home.offers.popular_badge": "Populaire",
  "home.offers.atelier.cta": "Découvrir les ateliers",
  "home.offers.cursus.cta": "Réserver",
  "home.offers.stage.cta": "Réserver",
  "home.gallery.eyebrow": "Galerie",
  "home.gallery.title": "Nos projets robotiques",
  "home.gallery.subtitle": "Des dizaines de projets Makeblock et Artec réalisés en atelier — voiture, sumo, lanceur, bipède et plus encore.",
  "home.gallery.cta": "Voir tous les projets",
  "home.gallery.1.title": "Voiture robotisée",
  "home.gallery.1.name": "Artec / Algora",
  "home.gallery.2.title": "Robot bipède",
  "home.gallery.2.name": "Artec / Algora",
  "home.gallery.3.title": "Robot chien",
  "home.gallery.3.name": "Makeblock",
  "home.gallery.4.title": "Crocobot",
  "home.gallery.4.name": "Makeblock",
  "home.gallery.5.title": "Catapulte",
  "home.gallery.5.name": "Makeblock",
  "home.gallery.6.title": "Lanceur d'avions en papier",
  "home.gallery.6.name": "Makeblock",
  "home.gallery.7.title": "Robot sumo",
  "home.gallery.7.name": "Makeblock",
  "home.gallery.8.title": "Voiture tout-terrain",
  "home.gallery.8.name": "Makeblock",
  "home.gallery.9.title": "Robot de combat",
  "home.gallery.9.name": "Makeblock",
  "home.gallery.10.title": "Robot footballeur",
  "home.gallery.10.name": "Makeblock",
  "home.gallery.11.title": "Créature robotique",
  "home.gallery.11.name": "Makeblock",
  "home.gallery.12.title": "Mille-pattes",
  "home.gallery.12.name": "Makeblock",
  "home.testimonials.eyebrow": "Témoignages",
  "home.testimonials.title": "Ce que disent les parents",
  "home.testimonials.subtitle": "Plus de 200 familles nous font confiance",
  "home.partners.eyebrow": "Ils nous font confiance",
  "home.partners.title": "Nos Partenaires & Technologies",
  "home.cta.title": "Prêt à commencer l'aventure ?",
  "home.cta.subtitle": "Réservez un atelier découverte offert et laissez votre enfant explorer la robotique dans un cadre bienveillant et stimulant.",
  "home.cta.primary": "Réserver maintenant",
  "home.cta.secondary": "Nous contacter",
  "cursus.hero.badge": "Formation annuelle complète",
  "cursus.hero.title": "Cursus Annuel Robotique & Programmation",
  "cursus.hero.subtitle": "30 séances progressives sur une année scolaire. Votre enfant apprend la robotique et la programmation, encadré par nos formateurs.",
  "cursus.hero.cta": "Réserver ma place",
  "cursus.hero.stat.1.label": "Séances",
  "cursus.hero.stat.2.label": "ou 115€/mois",
  "cursus.hero.stat.3.label": "6-16 ans",
  "cursus.video.eyebrow": "Découvrir",
  "cursus.video.title": "Une année pour maîtriser la robotique",
  "cursus.video.subtitle": "Parcours structuré, projets concrets et accompagnement personnalisé",
  "cursus.levels.eyebrow": "Cursus",
  "cursus.levels.title": "Le cursus annuel DigiRobot",
  "cursus.levels.subtitle": "Un seul cursus, de 6 à 16 ans — le programme s'adapte à chaque enfant",
  "cursus.planning.eyebrow": "Planning",
  "cursus.planning.title": "Horaires et centres disponibles",
  "cursus.planning.subtitle": "Choisissez le centre le plus proche de chez vous",
  "cursus.planning.cta": "Réserver ma place maintenant",
  "cursus.waitlist.cta": "S'il n'y a plus de place pour le créneau de votre choix, cliquez ici",
  "cursus.waitlist.title": "Liste d'attente",
  "cursus.waitlist.subtitle": "Laissez vos coordonnées : on traite la demande à la main et on vous rappelle.",
  "cursus.anchors.eyebrow": "En savoir plus",
  "cursus.anchors.course": "Comment se déroule un cours ?",
  "cursus.anchors.planning": "Planning et horaires",
  "cursus.anchors.gallery": "Les projets des élèves",
  "cursus.anchors.faq": "Questions fréquentes",
  "cursus.year.eyebrow": "Parcours",
  "cursus.year.title": "Comment se déroule l'année ?",
  "cursus.year.subtitle": "Un parcours progressif de septembre à juin",
  "cursus.year.1.title": "Septembre - Décembre",
  "cursus.year.1.text": "Découverte et bases de la robotique. Votre enfant construit ses premiers robots et apprend la programmation visuelle.",
  "cursus.year.2.title": "Janvier - Mars",
  "cursus.year.2.text": "Perfectionnement. Projets plus complexes avec capteurs et actionneurs. Votre enfant code des robots autonomes.",
  "cursus.year.3.title": "Avril - Juin",
  "cursus.year.3.text": "Projet final et certification. Votre enfant crée son propre robot et présente son projet. Certificat de compétences remis !",
  "cursus.gallery.title": "Un programme, des dizaines de projets",
  "cursus.gallery.subtitle": "Au fil de l'année, les enfants construisent et programment des robots de plus en plus ambitieux, adaptés à leur niveau.",
  "cursus.gallery.cta": "Explorer les projets",
  "cursus.skills.eyebrow": "Compétences",
  "cursus.skills.title": "Ce que votre enfant va maîtriser",
  "cursus.skills.subtitle": "Des compétences concrètes et valorisantes pour son avenir",
  "cursus.skills.1.title": "Construction",
  "cursus.skills.1.text": "Assemblage de robots complexes avec capteurs et moteurs",
  "cursus.skills.2.title": "Programmation",
  "cursus.skills.2.text": "Scratch, Python ou Arduino selon le niveau",
  "cursus.skills.3.title": "Résolution",
  "cursus.skills.3.text": "Logique, algorithmique et pensée critique",
  "cursus.skills.4.title": "Créativité",
  "cursus.skills.4.text": "Projets personnalisés et imagination sans limites",
  "cursus.why.eyebrow": "Nos atouts",
  "cursus.why.title": "Pourquoi choisir notre cursus annuel ?",
  "cursus.why.1.title": "Matériel fourni sur place",
  "cursus.why.1.text": "Robots, capteurs et outils sont mis à disposition pendant les séances. Rien à acheter ni à emporter.",
  "cursus.why.2.title": "Petits groupes de 8-10",
  "cursus.why.2.text": "Suivi personnalisé avec des formateurs passionnés. Chaque enfant avance à son rythme.",
  "cursus.why.3.title": "Accès e-learning gratuit",
  "cursus.why.3.text": "Plateforme en ligne avec +50 modules vidéo pour réviser et aller plus loin à la maison.",
  "cursus.testimonials.eyebrow": "Témoignages",
  "cursus.testimonials.title": "Ce que disent les parents",
  "cursus.faq.eyebrow": "FAQ",
  "cursus.faq.title": "Questions fréquentes",
  "cursus.faq.subtitle": "Tout ce que vous devez savoir sur le cursus annuel",
  "cursus.cta.title": "Offrez à votre enfant une année extraordinaire !",
  "cursus.cta.subtitle": "Réservez maintenant sa place dans notre cursus annuel. Paiement en 10 fois sans frais.",
  "cursus.cta.button": "Réserver maintenant - 1150€",
  "ateliers.hero.badge": "Premier atelier offert",
  "ateliers.hero.title": "Offrez à votre enfant les compétences du futur",
  "ateliers.hero.subtitle": "Des ateliers robotique et programmation sur mesure pour les 6-16 ans. Développez la créativité, la logique et la confiance de votre enfant.",
  "ateliers.hero.cta": "Réserver l'atelier GRATUIT",
  "ateliers.hero.ctaSecondary": "Nous contacter",
  "ateliers.hero.stat.1.label": "Enfants formés",
  "ateliers.hero.stat.2.label": "Satisfaction parents",
  "ateliers.hero.stat.3.label": "Centres",
  "ateliers.video.eyebrow": "Vidéo",
  "ateliers.video.title": "Découvrez un atelier DigiRobot",
  "ateliers.video.subtitle": "Immergez-vous dans l'univers passionnant de nos ateliers",
  "ateliers.formulas.eyebrow": "Formules",
  "ateliers.formulas.title": "Nos formules d'ateliers",
  "ateliers.formulas.subtitle": "Choisissez la formule adaptée aux besoins de votre enfant",
  "ateliers.how.eyebrow": "Simple et efficace",
  "ateliers.how.title": "Comment ça marche ?",
  "ateliers.how.subtitle": "En 3 étapes simples, votre enfant commence l'aventure",
  "ateliers.how.1.title": "Réservez en ligne",
  "ateliers.how.1.text": "Choisissez votre centre et votre créneau parmi nos disponibilités",
  "ateliers.how.2.title": "Votre enfant découvre",
  "ateliers.how.2.text": "Il apprend en s'amusant avec nos formateurs passionnés",
  "ateliers.how.3.title": "Il progresse",
  "ateliers.how.3.text": "Vous voyez ses compétences se développer semaine après semaine",
  "ateliers.planning.eyebrow": "Planning",
  "ateliers.planning.title": "Quand et où s'inscrire ?",
  "ateliers.planning.subtitle": "Choisissez le centre et l'horaire qui vous conviennent",
  "ateliers.planning.alert.title": "Places limitées !",
  "ateliers.planning.alert.text": "Plus que 12 places disponibles ce mois-ci. Les créneaux se remplissent rapidement. Réservez maintenant pour garantir votre place !",
  "ateliers.skills.eyebrow": "Compétences",
  "ateliers.skills.title": "Ce que votre enfant va apprendre",
  "ateliers.skills.subtitle": "Des compétences concrètes pour son avenir",
  "ateliers.skills.1.title": "Robotique",
  "ateliers.skills.1.text": "Construction et programmation de robots",
  "ateliers.skills.2.title": "Programmation",
  "ateliers.skills.2.text": "Scratch, Python, Arduino",
  "ateliers.skills.3.title": "Logique",
  "ateliers.skills.3.text": "Résolution de problèmes complexes",
  "ateliers.skills.4.title": "Créativité",
  "ateliers.skills.4.text": "Projets personnalisés et innovants",
  "ateliers.why.eyebrow": "Nos atouts",
  "ateliers.why.title": "Pourquoi les parents choisissent DigiRobot",
  "ateliers.why.1.title": "Premier atelier OFFERT",
  "ateliers.why.1.text": "Testez sans risque. Votre enfant découvre gratuitement avant tout engagement.",
  "ateliers.why.2.title": "Petits groupes de 8-10",
  "ateliers.why.2.text": "Suivi personnalisé avec des formateurs passionnés et qualifiés.",
  "ateliers.why.3.title": "5 centres sur la Côte d'Azur",
  "ateliers.why.3.text": "Nice, Cannes, Monaco, Pégomas, Cagnes-sur-Mer. Proche de chez vous.",
  "ateliers.testimonials.eyebrow": "Témoignages",
  "ateliers.testimonials.title": "Ce que disent les parents",
  "ateliers.faq.eyebrow": "FAQ",
  "ateliers.faq.title": "Questions fréquentes",
  "ateliers.faq.subtitle": "Tout ce que vous devez savoir avant de réserver",
  "ateliers.gallery.title": "50+ projets réalisables en atelier",
  "ateliers.gallery.subtitle": "Chaque séance, les enfants construisent et programment un robot différent — du bulldozer au robot sumo, en passant par le lanceur d'avions.",
  "ateliers.cta.title": "Prêt à offrir le meilleur à votre enfant ?",
  "ateliers.cta.subtitle": "Réservez maintenant votre atelier découverte GRATUIT et voyez la différence !",
  "ateliers.cta.footer": "Sans engagement · Annulation gratuite 48h avant · Satisfait ou remboursé",
  "ateliers.cta.button": "Réserver l'atelier GRATUIT",
  "stages.hero.badge": "Stages vacances thématiques",
  "stages.hero.title": "Stages Vacances par Thème",
  "stages.hero.subtitle": "6 thèmes passionnants ! Choisissez la durée (10h ou 20h) et le thème qui passionne votre enfant : Arduino, Drone, Lego, Makeblock et plus encore.",
  "stages.hero.cta": "Réserver un stage",
  "stages.hero.ctaSecondary": "Nous contacter",
  "stages.hero.stat.1.label": "Thèmes",
  "stages.hero.stat.2.label": "Au choix",
  "stages.hero.stat.3.label": "Dès 240€",
  "stages.video.eyebrow": "Vidéo",
  "stages.video.title": "Des vacances inoubliables",
  "stages.video.subtitle": "Découvrez l'ambiance de nos stages vacances",
  "stages.formulas.eyebrow": "Formules",
  "stages.formulas.title": "Choisissez votre formule",
  "stages.formulas.10h.title": "Formule 10h",
  "stages.formulas.10h.text": "Idéal pour découvrir",
  "stages.formulas.20h.title": "Formule 20h",
  "stages.formulas.20h.text": "Pour approfondir",
  "stages.themes.eyebrow": "Thématiques",
  "stages.themes.title": "6 thèmes passionnants",
  "stages.themes.subtitle": "Chaque thème disponible en 10h ou 20h",
  "stages.how.eyebrow": "Parcours",
  "stages.how.title": "Comment se déroule un stage ?",
  "stages.how.subtitle": "5 jours pour devenir un expert !",
  "stages.how.1.title": "Jour 1-2 : Découverte",
  "stages.how.1.text": "Prise en main du matériel et premiers projets simples. Votre enfant apprend les bases en s'amusant.",
  "stages.how.2.title": "Jour 3-4 : Création",
  "stages.how.2.text": "Projets plus complexes et créatifs. Votre enfant laisse libre cours à son imagination !",
  "stages.how.3.title": "Jour 5 : Présentation",
  "stages.how.3.text": "Projet final et présentation devant les autres. Fierté et confiance garanties !",
  "stages.skills.eyebrow": "Compétences",
  "stages.skills.title": "Compétences développées pendant le stage",
  "stages.skills.subtitle": "Bien plus que de la technique !",
  "stages.skills.1.title": "Technique",
  "stages.skills.1.text": "Construction, programmation et électronique selon le thème",
  "stages.skills.2.title": "Créativité",
  "stages.skills.2.text": "Expression libre et projets personnalisés",
  "stages.skills.3.title": "Collaboration",
  "stages.skills.3.text": "Travail en équipe et entraide",
  "stages.skills.4.title": "Confiance",
  "stages.skills.4.text": "Fierté de créer et de présenter son projet",
  "stages.why.eyebrow": "Nos atouts",
  "stages.why.title": "Pourquoi choisir nos stages vacances ?",
  "stages.why.1.title": "Formule flexible",
  "stages.why.1.text": "Choisissez 10h ou 20h selon votre planning. Tous les thèmes disponibles dans toutes les formules.",
  "stages.why.2.title": "Petits groupes de 10 max",
  "stages.why.2.text": "Encadrement optimal avec 1 formateur pour 10 enfants maximum. Chacun avance à son rythme.",
  "stages.why.3.title": "Tout le matériel fourni",
  "stages.why.3.text": "Robots, composants, ordinateurs... Tout est fourni ! Option robot à prix réduit pour Makeblock.",
  "stages.testimonials.eyebrow": "Témoignages",
  "stages.testimonials.title": "Retours de parents",
  "stages.faq.eyebrow": "FAQ",
  "stages.faq.title": "Questions fréquentes",
  "stages.faq.subtitle": "Tout ce que vous devez savoir sur nos stages",
  "stages.cta.title": "Offrez des vacances inoubliables à votre enfant !",
  "stages.cta.subtitle": "Réservez maintenant sa place pour les prochaines vacances. 6 thèmes disponibles en 10h ou 20h.",
  "stages.cta.footer": "Matériel fourni · Petits groupes · Tous niveaux acceptés",
  "stages.cta.button": "Réserver un stage — Dès 240€",
  "about.hero.badge": "Notre histoire",
  "about.hero.title": "À propos de DigiRobot",
  "about.hero.subtitle": "Ateliers de robotique et programmation pour les 6–18 ans sur la Côte d'Azur — un environnement bienveillant où chaque enfant progresse à son rythme.",
  "about.hero.body": "Depuis notre création, nous avons accompagné plus de 500 jeunes vers les compétences du numérique. Notre mission : rendre la robotique accessible, concrète et motivante pour tous.",
  "about.hero.cta": "Rejoignez l'aventure",
  "about.values.eyebrow": "Nos valeurs",
  "about.values.title": "Ce qui guide notre action",
  "about.values.subtitle": "Des principes concrets au service de chaque élève",
  "about.values.1.title": "Excellence",
  "about.values.1.text": "Programme pédagogique conçu par des experts et validé sur le terrain",
  "about.values.2.title": "Accessibilité",
  "about.values.2.text": "La robotique ouverte à tous, quel que soit le niveau de départ",
  "about.values.3.title": "Innovation",
  "about.values.3.text": "Méthodes actives, projets concrets et outils adaptés à chaque âge",
  "about.values.4.title": "Passion",
  "about.values.4.text": "Une équipe engagée qui transmet l'enthousiasme de la tech",
  "about.stats.1.label": "Élèves formés",
  "about.stats.2.label": "Centres",
  "about.stats.3.label": "Modules pédagogiques",
  "about.stats.4.label": "Parents satisfaits",
  "about.partner.eyebrow": "Partenariat",
  "about.partner.title": "Partenaire pédagogique Algora",
  "about.partner.subtitle": "DigiRobot s'appuie sur Algora, entreprise spécialisée dans l'éducation aux sciences informatiques, pour créer un programme de qualité et des séances pratiques adaptées à chaque niveau.",
  "about.partner.1.title": "Méthode éprouvée",
  "about.partner.1.text": "Programme testé et validé par des milliers d'élèves en France",
  "about.partner.2.title": "Robots de qualité",
  "about.partner.2.text": "Kits robotiques conçus spécifiquement pour l'apprentissage scolaire",
  "about.partner.3.title": "Formation continue",
  "about.partner.3.text": "Nos formateurs suivent régulièrement les dernières méthodes pédagogiques",
  "about.team.eyebrow": "L'équipe",
  "about.team.title": "Des formateurs passionnés",
  "about.team.subtitle": "Qualifiés, pédagogues et à l'écoute de chaque élève",
  "about.cta.title": "Rejoignez DigiRobot",
  "about.cta.subtitle": "Offrez à votre enfant les compétences du futur dans un environnement stimulant et bienveillant",
  "contact.hero.eyebrow": "Contact",
  "contact.hero.title": "Une question ? Parlons-en",
  "contact.hero.subtitle": "Besoin de renseignements ? Notre équipe est là pour vous répondre.",
  "contact.form.title": "Envoyez-nous un message",
  "contact.form.subtitle": "Nous vous répondrons dans les plus brefs délais (sous 24 h ouvrées)",
  "contact.info.title": "Informations de contact",
  "contact.info.subtitle": "Horaires et coordonnées générales",
  "contact.info.phone_label": "Téléphone",
  "contact.info.phone_hours": "Lun–Sam : 9h–18h",
  "contact.info.email_label": "Email",
  "contact.info.email_note": "Réponse sous 24 h",
  "contact.info.centers_label": "Nos centres",
  "contact.info.centers_note": "5 centres sur la Côte d'Azur",
  "contact.faq.title": "Questions fréquentes",
  "contact.centers.eyebrow": "Nos centres",
  "contact.centers.title": "Retrouvez-nous sur la Côte d'Azur",
  "contact.centers.subtitle": "Retrouvez-nous dans l'un de nos centres",
  "entreprises.hero.eyebrow": "B2B",
  "entreprises.hero.title": "Solutions pour entreprises & écoles",
  "entreprises.hero.subtitle": "Team building, formations professionnelles et partenariats pédagogiques sur mesure.",
  "entreprises.offers.eyebrow": "Offres",
  "entreprises.offers.title": "Nos formules B2B",
  "entreprises.offers.subtitle": "Team building, formations et partenariats adaptés à votre organisation.",
  "entreprises.why.eyebrow": "Nos atouts",
  "entreprises.why.title": "Pourquoi choisir DigiRobot ?",
  "entreprises.why.1.title": "Expérience unique",
  "entreprises.why.1.text": "Une activité originale qui marque les esprits",
  "entreprises.why.2.title": "Cohésion d'équipe",
  "entreprises.why.2.text": "Renforce la collaboration et la communication",
  "entreprises.why.3.title": "Sur mesure",
  "entreprises.why.3.text": "Solutions adaptées à vos besoins et objectifs",
  "entreprises.why.4.title": "Dans vos locaux",
  "entreprises.why.4.text": "Nous venons chez vous ou dans nos centres",
  "entreprises.cta.title": "Discutons de votre projet",
  "entreprises.cta.subtitle": "Contactez-nous pour recevoir un devis personnalisé et organiser votre événement",
  "elearning.hero.eyebrow": "Bientôt disponible",
  "elearning.hero.title": "DigiRobot Academy arrive bientôt",
  "elearning.hero.subtitle": "Notre plateforme e-learning avec plus de 50 modules vidéo est en cours de préparation. Inscrivez-vous à un cursus ou réservez un stage pour en profiter en avant-première.",
  "elearning.features.eyebrow": "Plateforme",
  "elearning.features.title": "Ce que propose l'Academy",
  "elearning.features.subtitle": "Une ressource complémentaire pour prolonger l'apprentissage à la maison.",
  "elearning.features.1.title": "+50 modules vidéo",
  "elearning.features.1.text": "Des cours progressifs du débutant au confirmé, accessibles à tout moment",
  "elearning.features.2.title": "Exercices pratiques",
  "elearning.features.2.text": "Des projets concrets pour mettre en application chaque leçon",
  "elearning.features.3.title": "Inclus au cursus",
  "elearning.features.3.text": "Accès gratuit pour tous les inscrits au cursus annuel",
  "elearning.waitlist.title": "Être prévenu du lancement",
  "elearning.waitlist.subtitle": "La plateforme sera accessible gratuitement aux inscrits au cursus annuel. Laissez votre email pour être prévenu du lancement.",
  "boutique.hero.eyebrow": "Boutique",
  "boutique.hero.title": "Robots & kits DigiRobot",
  "boutique.hero.subtitle": "Achetez votre robot et bénéficiez d'un accès gratuit à la plateforme e-learning pour apprendre à la maison.",
  "boutique.catalog.eyebrow": "Catalogue",
  "boutique.catalog.title": "Nos robots éducatifs",
  "boutique.catalog.subtitle": "Des kits adaptés à chaque tranche d'âge, avec support pédagogique inclus. Contactez-nous pour commander.",
  "boutique.why.eyebrow": "Nos engagements",
  "boutique.why.title": "Pourquoi acheter chez DigiRobot ?",
  "boutique.why.1.title": "E-learning offert",
  "boutique.why.1.text": "Accès gratuit à notre plateforme de cours pendant 3 à 12 mois selon le robot",
  "boutique.why.2.title": "Livraison rapide",
  "boutique.why.2.text": "Expédition sous 48h sur toute la France métropolitaine",
  "boutique.why.3.title": "Support expert",
  "boutique.why.3.text": "Nos formateurs vous accompagnent en cas de question",
  "boutique.cta.title": "Besoin de conseils ?",
  "boutique.cta.subtitle": "Pas sûr du robot adapté à votre enfant ? Contactez-nous pour des conseils personnalisés.",
  "navbar.home": "Accueil",
  "navbar.about": "À propos",
  "navbar.contact": "Contact",
  "navbar.boutique": "Boutique",
  "navbar.elearning": "E-learning",
  "navbar.entreprises": "Entreprises",
  "navbar.blog": "Blog",
  "navbar.offers.label": "Nos Offres",
  "navbar.offers.ateliers": "Ateliers Découverte",
  "navbar.offers.cursus": "Cursus Annuel",
  "navbar.offers.stages": "Stages Vacances",
  "navbar.cta_reserve": "Réserver un atelier",
  "navbar.contact_cta": "Nous contacter",
  "footer.tagline": "Robotique & programmation pour enfants",
  "footer.description": "Ateliers de robotique et programmation pour enfants et ados. Cultivons ensemble les compétences du futur.",
  "footer.offers.title": "Nos Offres",
  "footer.offers.ateliers": "Ateliers Découverte",
  "footer.offers.cursus": "Cursus Annuel",
  "footer.offers.stages": "Stages Vacances",
  "footer.offers.boutique": "Boutique Robots",
  "footer.offers.elearning": "Plateforme E-learning",
  "footer.offers.entreprises": "Offres Entreprises",
  "footer.info.title": "Informations",
  "footer.info.about": "À Propos",
  "footer.info.blog": "Blog",
  "footer.info.contact": "Contact",
  "footer.info.mentions": "Mentions Légales",
  "footer.info.politique": "Politique de Confidentialité",
  "footer.info.rgpd": "RGPD",
  "footer.info.cgv": "CGV",
  "footer.contact.title": "Contact",
  "footer.copyright": "Tous droits réservés. Partenaire pédagogique Algora.",
  "cursus.hero.floating_badge": "Certificat inclus",
  "cursus.card.cta": "Réserver",
  "cursus.planning.empty": "Les horaires seront bientôt disponibles. Contactez-nous pour plus d'informations.",
  "cursus.cta.footer": "Matériel fourni sur place · E-learning gratuit · Certificat de compétences",
  "cursus.testimonials.rating": "4.9/5 sur 200+ avis",
  "cursus.faq.1.question": "Mon enfant peut-il rejoindre en cours d'année ?",
  "cursus.faq.1.answer": "Oui, selon les places disponibles et le niveau de votre enfant. Nous proposons une séance de rattrapage pour qu'il soit à niveau avec le groupe.",
  "cursus.faq.2.question": "Que se passe-t-il si mon enfant manque plusieurs séances ?",
  "cursus.faq.2.answer": "Accès illimité à notre plateforme e-learning pour rattraper les cours manqués. Des séances de rattrapage sont également organisées pendant les vacances.",
  "cursus.faq.3.question": "Le matériel est-il fourni ?",
  "cursus.faq.3.answer": "Oui, tout le matériel (robots, capteurs, outils) est fourni sur place pendant les séances. Les enfants n'emportent pas de kit à la maison.",
  "cursus.faq.4.question": "Y a-t-il une évaluation à la fin ?",
  "cursus.faq.4.answer": "Oui, votre enfant reçoit un certificat de compétences DigiRobot détaillant tout ce qu'il a appris. C'est un vrai plus pour son parcours scolaire !",
  "cursus.faq.5.question": "Puis-je payer en plusieurs fois ?",
  "cursus.faq.5.answer": "Absolument ! Nous proposons un paiement en 10 mensualités de 115€ sans frais. Vous pouvez aussi payer en 3 fois.",
  "stages.hero.floating_badge": "Tous niveaux",
  "stages.formulas.day.title": "Journée",
  "stages.formulas.day.text": "Une journée complète",
  "stages.formulas.demi-journee.point.1": "5 matinées de 2h",
  "stages.formulas.demi-journee.point.2": "Matériel fourni",
  "stages.formulas.day.point.1": "9h – 16h",
  "stages.formulas.day.point.2": "Matériel fourni",
  "stages.formulas.semaine.point.1": "5 journées encadrées",
  "stages.formulas.semaine.point.2": "Projet personnel inclus",
  "stages.formulas.popular_badge": "POPULAIRE",
  "stages.formulas.cta": "Réserver cette formule",
  "stages.themes.robot_badge": "+ Robot",
  "stages.themes.robot_option_label": "Option Robot",
  "stages.card.cta": "Réserver",
  "stages.testimonials.rating": "4.9/5 sur 200+ avis",
  "stages.faq.1.question": "Mon enfant peut-il venir sans expérience ?",
  "stages.faq.1.answer": "Absolument ! Nos stages sont adaptés à tous les niveaux, débutants comme confirmés. Nous créons des groupes homogènes selon l'âge et le niveau.",
  "stages.faq.2.question": "Les repas sont-ils inclus ?",
  "stages.faq.2.answer": "Non, les repas ne sont pas inclus. Prévoyez un pique-nique pour votre enfant. Nous avons un espace dédié pour le déjeuner avec micro-ondes disponible.",
  "stages.faq.3.question": "Puis-je choisir plusieurs thèmes ?",
  "stages.faq.3.answer": "Oui ! Votre enfant peut faire plusieurs stages pendant les vacances. Nous proposons des stages sur toutes les périodes de vacances scolaires.",
  "stages.faq.4.question": "L'option robot Makeblock, comment ça marche ?",
  "stages.faq.4.answer": "Pour le stage Makeblock, vous pouvez acheter le robot à prix réduit (+60€ à +90€). Votre enfant le garde et peut continuer à programmer chez lui !",
  "stages.faq.5.question": "Que faire si mon enfant est malade ?",
  "stages.faq.5.answer": "Nous proposons un report sur un prochain stage ou un avoir valable 1 an sur présentation d'un certificat médical.",
  "ateliers.hero.floating_badge": "Satisfait ou remboursé",
  "ateliers.video.overlay_label": "Regarder la vidéo (2 min)",
  "ateliers.formulas.free_badge": "OFFERT",
  "ateliers.card.cta": "Réserver",
  "ateliers.card.cta_free": "Réserver gratuitement",
  "ateliers.card.cta_rdv": "Demander un rendez-vous",
  "ateliers.planning.empty": "Les horaires seront bientôt disponibles.",
  "ateliers.testimonials.rating": "4.9/5 sur 200+ avis",
  "ateliers.faq.1.question": "À partir de quel âge peut-on commencer ?",
  "ateliers.faq.1.answer": "Nos cursus et ateliers sont ouverts dès 6 ans, avec des programmes adaptés à chaque tranche d'âge (6-8, 9-12 et 13-16 ans).",
  "ateliers.faq.2.question": "Quelle est la durée des sessions hebdomadaires ?",
  "ateliers.faq.2.answer": "Les sessions hebdomadaires du cursus annuel durent entre 60 et 120 minutes, selon le niveau et le centre.",
  "ateliers.faq.3.question": "Proposez-vous des stages pendant les vacances ?",
  "ateliers.faq.3.answer": "Oui, nous proposons des stages passionnants pendant les vacances, sur une durée de 10 à 12 heures (formules 10h ou 20h disponibles).",
  "ateliers.faq.4.question": "Faut-il avoir des connaissances préalables ?",
  "ateliers.faq.4.answer": "Non, aucune connaissance n'est requise. Nos programmes sont conçus pour accueillir les débutants complets et progresser à leur rythme.",
  "ateliers.faq.5.question": "Que se passe-t-il si mon enfant manque une séance ?",
  "ateliers.faq.5.answer": "Nous proposons des séances de rattrapage et l'accès à la plateforme e-learning permet de suivre les cours manqués en vidéo.",
  "ateliers.faq.6.question": "Le matériel est-il fourni ?",
  "ateliers.faq.6.answer": "Oui, tout le matériel est fourni en centre pendant les ateliers, les stages et le cursus. Les robots restent sur place.",
  "ateliers.faq.7.question": "Combien d'enfants par groupe ?",
  "ateliers.faq.7.answer": "Nous limitons les groupes à 8-10 enfants maximum pour garantir un suivi personnalisé et une attention optimale de nos formateurs.",
  "ateliers.faq.8.question": "Puis-je visiter vos locaux avant de m'inscrire ?",
  "ateliers.faq.8.answer": "Absolument ! Nous proposons des portes ouvertes régulières et vous pouvez prendre rendez-vous pour visiter nos centres à tout moment.",
  "about.cta.primary": "Réserver un atelier",
  "about.cta.secondary": "Nous contacter",
  "about.team.1.name": "Formateur 1",
  "about.team.2.name": "Formateur 2",
  "about.team.3.name": "Formateur 3",
  "about.team.4.name": "Formateur 4",
  "about.team.role": "Expert robotique",
  "contact.faq.1.question": "À partir de quel âge peut-on commencer ?",
  "contact.faq.2.question": "Faut-il des connaissances préalables ?",
  "contact.faq.3.question": "Le matériel est-il fourni ?",
  "contact.faq.4.question": "Combien d'enfants par groupe ?",
  "elearning.hero.cta_primary": "Voir les cursus",
  "elearning.hero.cta_secondary": "Réserver un atelier",
  "elearning.waitlist.submit": "Me prévenir du lancement",
  "elearning.waitlist.privacy_note": "Vos données restent confidentielles",
  "entreprises.card.cta": "Demander un devis",
  "entreprises.references.eyebrow": "Références",
  "entreprises.references.title": "Ils nous font confiance",
  "entreprises.references.subtitle": "Écoles et partenaires pédagogiques",
  "entreprises.cta.button": "Demander un devis",
  "boutique.empty.title": "Catalogue bientôt disponible",
  "boutique.empty.text": "Nos kits robotiques arrivent prochainement. Contactez-nous pour être conseillé en attendant.",
  "boutique.empty.cta": "Nous contacter",
  "boutique.cta.button": "Contactez-nous",
  "blog.hero.eyebrow": "Blog",
  "blog.hero.title": "Actualités DigiRobot",
  "blog.hero.subtitle": "Actualités, conseils et ressources sur la robotique éducative pour parents et enseignants",
  "blog.empty.title": "Aucun article pour le moment",
  "blog.empty.text": "Revenez bientôt pour découvrir nos actualités, conseils et retours d'expérience sur la robotique éducative.",
  "blog.empty.cta": "Nous contacter",
  "blog.featured.badge": "Article en vedette",
  "blog.featured.cta": "Lire l'article",
  "blog.list.eyebrow": "Publications",
  "blog.list.title": "Derniers articles",
  "blog.list.empty": "Un seul article pour le moment — d'autres arrivent bientôt !",
  "blog.card.cta": "Lire la suite",
  "blog.cta.title": "Restez informé",
  "blog.cta.subtitle": "Inscrivez-vous à notre newsletter pour recevoir nos derniers articles et actualités sur la robotique éducative.",
  "blog.cta.footer": "Pas de spam — désinscription possible à tout moment.",
  "blog.cta.button": "S'abonner",
  "welcome.popup.cta_expand": "En savoir plus",
  "welcome.popup.cta_reserve": "Réserver",
  "welcome.popup.cta_submit": "Être recontacté sous 24h",
  "home.testimonials.rating": "4.9/5 sur 200+ avis"
};

export const CONTENT_KEYS = Object.keys(DEFAULT_TEXTS);
